@if (show()) {
  <div class="section-hidden-notice uk-flex uk-flex-between uk-flex-middle">
    <div class="uk-flex uk-flex-middle">
      <span class="material-symbols-outlined">block</span>
      <div class="uk-margin-small-left">
        <div class="section-hidden-notice__title uk-text-bold">This section is hidden from the live page</div>
        <div>
          Visitors won't see this section or its left-nav entry.
          Toggle the section on to restore it.
        </div>
      </div>
    </div>
    <button
            class="uk-button uk-button-primary--pink uk-flex-none uk-text-nowrap"
            (click)="service.showGroup(sectionName())">
      Restore section
    </button>
  </div>
}
